/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import WidgetApiService from '@/common/services/widget-api.service';
// POST a single file to its presigned S3 URL. The ticket.fields carry the
// server-derived key and policy; S3 requires the `file` field appended last.
// Uses a bare axios (no widget-api baseURL or auth headers) so the browser
// sets the multipart boundary, and returns the server-provided objectUrl.
export async function uploadToPresignedUrl(ticket, file) {
    const formData = new FormData();
    Object.entries(ticket.fields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    formData.append('file', file);
    try {
        await axios.post(ticket.url, formData);
        return ticket.objectUrl;
    }
    catch (e) {
        throw new Error('failed to upload to s3');
    }
}
// Correlate a response ticket to its source file by (docType, index).
function findTicket(tickets, descriptor) {
    return tickets.find(t => t.docType === descriptor.docType && t.index === descriptor.index);
}
// Request server-derived presigned tickets from widget-api, upload each file to
// its ticket, and stamp each data item's `res` with the server-provided
// objectUrl (preserving the contract BeginKYC relies on). The object key is
// derived server-side from the authenticated identity — the client never picks
// it. Any failure aborts the whole batch, so BeginKYC never submits partial data.
export async function uploadKycFilesToS3(files, token, sessionId, deviceId) {
    try {
        const descriptors = files.map(data => ({
            docType: data.type,
            contentType: data.file.type || 'image/jpeg',
            contentLength: data.file.size,
            index: data.index,
        }));
        const { tickets } = await WidgetApiService.GetKycUploadUrls(token, sessionId, deviceId, { files: descriptors });
        return await Promise.all(files.map(async (data, i) => {
            const ticket = findTicket(tickets, descriptors[i]);
            if (!ticket) {
                throw new Error('missing upload ticket for file');
            }
            data.res = await uploadToPresignedUrl(ticket, data.file);
            return data;
        }));
    }
    catch (e) {
        throw new Error('failed to upload docs to s3');
    }
}
